<template>
  <div class="app-container">
    <PurchaseViewForm />
  </div>
</template>
<script>
import PurchaseViewForm from '@/views/center-business/purchase/order/components/CsgPurchaseViewForm.vue';
export default {
  name: 'BusinessPurchaseOrderCsgAdd',
  components: { PurchaseViewForm },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
